import React, { useEffect, useState } from "react"
import { Modal, Form, Row, Col, Spin, Tag } from "antd"
import moment from "moment"
import WarehouseService from "src/services/WarehouseService"
import { SectionCard, SectionTitle } from "./styleds"

const ModalDetailData = ({ open, onCancel, record }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open && record?.ID) {
      fetchDetailData()
    } else {
      setData(null)
    }
  }, [record])

  const fetchDetailData = async () => {
    setLoading(true)
    try {
      const response = await WarehouseService.getDetailData(record.ID)
      const detail = response?.success || {}
      setData(detail)
    } catch (error) {
      console.error("Lỗi khi lấy chi tiết data:", error)
    } finally {
      setLoading(false)
    }
  }
  const formatDate = date => (date ? moment(date).format("DD/MM/YYYY") : "--")

  const formatNumber = num =>
    !isNaN(num) ? Number(num).toLocaleString() : "--"

  const renderValue = value => <span>{value || "--"}</span>

  return (
    <Modal
      title="Chi tiết phiếu nhập kho"
      open={open}
      onCancel={onCancel}
      width={1000}
      footer={null}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form layout="vertical">
          {/* Thông tin cơ bản */}
          <SectionCard>
            <SectionTitle>Thông tin chung</SectionTitle>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Nhà cung cấp">
                  {renderValue(data?.supplier?.name)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Quốc gia">
                  {renderValue(data?.country?.title)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Nhà mạng">
                  {renderValue(data?.network?.name)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Ngày nhập">
                  {renderValue(formatDate(data?.created_at))}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Trạng thái">
                  {(() => {
                    switch (data?.type) {
                      case "0":
                        return <Tag color="orange">Chờ duyệt</Tag>
                      case "1":
                        return <Tag color="green">Đã duyệt</Tag>
                      case "2":
                        return <Tag color="red">Từ chối</Tag>
                      default:
                        return <Tag color="default">Không xác định</Tag>
                    }
                  })()}
                </Form.Item>
              </Col>
              {data?.type == "2" && (
                <Col span={12}>
                  <Form.Item label="Lý do từ chối">
                    {renderValue(data?.note)}
                  </Form.Item>
                </Col>
              )}
            </Row>
          </SectionCard>
           <SectionCard>
                      <SectionTitle>Thông tin dữ liệu</SectionTitle>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Đơn giá data">
                {renderValue(`${formatNumber(data?.unit_price)}`)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Dung lượng data">
                {renderValue(formatNumber(data?.total_data))}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Data sử dụng">
                {renderValue(formatNumber(data?.data_used))}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Data còn lại">
                {renderValue(formatNumber(data?.data_remaining))}
              </Form.Item>
            </Col>
          </Row>
          </SectionCard>
          <SectionCard>
            <SectionTitle>Thông tin chiết khấu</SectionTitle>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Loại chiết khấu">
                  {renderValue(
                    data?.discount_type === "percent"
                      ? "Chiết khấu %"
                      : data?.discount_type === "fixed"
                      ? "Chiết khấu số tiền"
                      : data?.discount_type,
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Chiết khấu">
                  {parseInt(data?.discount || "0", 10)}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Tổng tiền">
                  {renderValue(formatNumber(data?.total_amount))}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Thành tiền sau chiết khấu">
                  {renderValue(formatNumber(data?.total_discord))}
                </Form.Item>
              </Col>
            </Row>
          </SectionCard>
        </Form>
      </Spin>
    </Modal>
  )
}

export default ModalDetailData
